import { render, staticRenderFns } from "./third-step.vue?vue&type=template&id=2f0ca348&"
import script from "./third-step.vue?vue&type=script&lang=js&"
export * from "./third-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports